import theme from 'styled-theming';
import styled, { css } from 'styled-components';
import { LabelBold } from '@comeon/ui';

import breakpoint from '~/utils/style-utils';

const pillBrandException = theme('brand', {
	lyllo: css`
		h5 {
			text-transform: uppercase;
		}
	`
});

const PillStyles = styled.button`
	background-color: ${({ $active }) =>
		$active ? `var(--filter-pills-bg-active)` : `var(--filter-pills-bg)`} !important;
	border-radius: var(--brand-filter-pills-border-radius, 25px);
	display: inline-flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	//margin-right: 8px;
	padding: 0 16px;
	height: 28px;
	text-align: center;
	transition: 200ms background-color ease-in;
	a,
	h5 {
		color: ${({ $active }) =>
			$active ? `var(--filter-pills-text-color-active)` : `var(--filter-pills-text-color)`};
		font-size: 12px;
		line-height: 16px;
		> label {
			padding-top: 6px;
		}
	}
	${breakpoint.lg`
		height: 36px;
		padding: 0px 12px;

		h5 {
			font-size: 15px;
			line-height: 20px;
			> label {
			padding-top: 8px;
		}
		}
	`};
	${pillBrandException};
`;

const WeSpinPillsLikeButton = ({ children, onClick, disabled, active, ...props }) => {
	return (
		<PillStyles onClick={onClick} disabled={disabled} $active={active} className="btn" {...props}>
			<LabelBold>{children}</LabelBold>
		</PillStyles>
	);
};

export default WeSpinPillsLikeButton;
